
import SharedNavigation from '../../components/feature/SharedNavigation';
import CompanyHero from './components/CompanyHero';
import CompanyMission from './components/CompanyMission';
import CompanyOverview from './components/CompanyOverview';
import CompanyTimeline from './components/CompanyTimeline';
import CompanyContact from './components/CompanyContact';
import SharedFooter from '../../components/feature/SharedFooter';

export default function CompanyPage() {
  return (
    <div className="relative">
      <SharedNavigation subLabel="Company" />
      <CompanyHero />
      <CompanyMission />
      <CompanyOverview />
      <CompanyTimeline />
      <CompanyContact />
      <SharedFooter />
    </div>
  );
}
